<template>
  <div>
    <div
      v-if="device === 'desktop'"
      :class="['box-component', 'tva-row', {'active' : active}, {'small' : content.style === 'small'}]"
      :style="{height: content.style ? minHeight * content.content.length + 'px' : maxHeight * content.content.length + 'px'}"
    >
      <div class="box-component-wrapper tva-col-md-offset-3 tva-col-md-6 tva-col-md-8 tva-col-sm-offset-2 tva-col-sm-8">
        <div :class="['box-container ']" v-for="(element, index) in content.content" :key="index">
          <transition name="slide">
            <div
              :class="['box-wrapper', {'small' : content.style === 'small'}]"
              v-if="offset !== null && +(offset /  (1 / content.content.length)).toFixed(0) >= index"
            >
              <h5 v-if="element.title">{{element.title}}</h5>
              <div class="box">{{element.content}}</div>
            </div>
          </transition>
          <transition name="line">
            <div
              class="line"
              v-if="offset !== null && +(offset /  (1 / content.content.length)).toFixed(0) >= index"
            ></div>
          </transition>
        </div>
      </div>
    </div>
    <div v-if="device === 'mobile'" :class="['box-component', 'tva-row']">
      <div class="box-component-wrapper tva-col-md-offset-3 tva-col-md-6">
        <div :class="['box-container ']" v-for="(element, index) in content.content" :key="index">
          <div :class="['box-wrapper', {'small' : content.style === 'small'}]">
            <h5 v-if="element.title">{{element.title}}</h5>
            <div class="box">{{element.content}}</div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active", "offset"],
  watch: {
    offset(value) {
      if (value !== null) this.computedOffset = value;
    }
  },
  data() {
    return {
      computedOffset: null,
      maxHeight: 240,
      minHeight: 170,
      mobileHeight: 300,
      device: ""
    };
  },
  created() {
    this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    window.addEventListener("resize", () => {
      this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.box-component {
  position: relative;
  margin-top: 70px;
  .box-container {
    position: relative;
    margin-bottom: 34px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 24px;
    .box-wrapper {
      border: solid 3px black;
      padding: 40px 24px 30px 24px !important;
      min-height: 200px;
      transition: all 0.6s ease;
      &.small {
        min-height: 130px;
      }
    }
    .line {
      height: 10px;
      width: 60px;
      position: absolute;
      top: 20px;
      left: -30px;
      background: $terna-light-blu;
      // transition-delay: 0.6s;
      transition: all 0.6s ease;
    }
    .slide-enter-to,
    .slide-leave {
      opacity: 1;
      transform: translate(0);
    }
    .slide-enter {
      transform: translateX(100%);
      opacity: 0;
    }
    .slide-leave-to {
      transform: translateX(-100%);
      opacity: 0;
    }
  }
}
.line-enter-to,
.line-leave {
  opacity: 1;
  transform: translate(0);
}
.line-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.line-leave-to {
  transform: translateX(-500px);
  opacity: 0;
}

@media (max-width: 768px) {
  .box-component {
    position: relative;
    margin-top: 30px;
    height: auto !important;
    min-height: 50px;
    &.small {
      height: auto !important;
    }
    .box-component-wrapper {
      position: relative;
      .box-container {
        position: relative;
        transform: translateX(0);
        .slide-enter,
        .slide-leave-to {
          transform: translateX(0);
          opacity: 1;
        }
        .box-wrapper {
          transform: translateX(0);
          &.small {
            min-height: auto;
          }
        }
        .line {
          width: 30px;
          left: 0px;
        }
      }
    }
  }
}
</style>
